import Cookies from 'js-cookie';
const passObj: { [name: string]: string } = { "3": "AtEGrTRH4Sz8iv4wrwUg8DQZbJtTUB8Q", "2": "Ae79qqUei2VsKd2pVvxkv5GvMnEALtvW" }
export default class BasicUtil {
  public static getUrlParams() {
    const urls = location.pathname.split("?")
    if (urls.length == 0) return []
    const url = urls[0]
    const arr = url.split("/")
    let first = ""
    let second = ""
    let third = ""
    let forth = ""
    if (arr.length > 1) first = arr[1]
    if (arr.length > 2) second = arr[2]
    if (arr.length > 3) third = arr[3]
    if (arr.length > 4) forth = arr[4]
    return [first, second, third, forth]
  }

  public static getQueryParams(): { [s: string]: string } {
    var queryString = window.location.search;
    var queryObject: { [s: string]: string } = {};
    if (queryString) {
      queryString = queryString.substring(1);
      var parameters = queryString.split('&');

      for (var i = 0; i < parameters.length; i++) {
        var element = parameters[i].split('=');

        var paramName = decodeURIComponent(element[0]);
        var paramValue = decodeURIComponent(element[1]);

        queryObject[paramName] = paramValue;
      }
    }
    return queryObject;
  }

  public static isAllow() {
    try {
      localStorage.test = 'tacapp';
      return true
    } catch (e) {
      return false
    }
  }

  public static getSc() {
    var CryptoJS = require('crypto-js');
    var key = CryptoJS.enc.Utf8.parse('XVhujmigeff2LHzaaUXjb5vq5X27dKSp');
    var iv = CryptoJS.enc.Utf8.parse('8337349822330635');
    var dateTime = new Date().toUTCString()
    var srcs = CryptoJS.enc.Utf8.parse(dateTime);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    return encrypted.ciphertext.toString();
  }

  public static getPathType(type: number, categoryId: number | undefined) {
    if (type == 1) {
      return "category/" + String(categoryId)
    } else if (type == 2) {
      return "exam"
    } else if (type == 3) {
      return "shiwake/q"
    }
    return ""
  }

  public setBasicSetting() {
    
  }

  public removeBasicSetting() {
    window.onbeforeunload = null
  }

  /**
   * [0]htmlString [1] resultのcomponent
   * @param vm 
   * @param content 
   */
  public static parseHtml(vm: any, content: string): any {
    // const domparser = new DOMParser();
    // const htmlDoc = domparser.parseFromString(
    //   content,
    //   "text/html"
    // );
    // const sections: HTMLCollection = htmlDoc.getElementsByTagName("section");
    // const instances: any = []
    // let resultInstance: any = null
    // const ids: string[] = []
    // Array.prototype.forEach.call(sections, function (item: HTMLElement) {
    //   const propsData: any = {};
    //   let isResult: boolean = false
    //   if (item.dataset.data) propsData["data"] = item.dataset.data;
    //   if (item.dataset.options) {
    //     propsData["shiwakeOptions"] = item.dataset.options;
    //   }
    //   if (item.id == "result") {
    //     isResult = true
    //     propsData["data"] = vm.question.questionResult;
    //   }
    //   const instance = BasicUtil.getComponent(vm.classes, item.dataset.tag, propsData)
    //   if (instance) {
    //     instance.$mount();
    //     instances.push(instance);
    //   }
    //   if (isResult) {
    //     resultInstance = instance
    //   }
    //   const uuid = "i" + uuidv4()
    //   ids.push(uuid)
    //   content = content.replace("id='" + item.id + "'", "id='" + uuid + "'")
    //   content = content.replace("id=\"" + item.id + "\"", "id='" + uuid + "'")
    // });
    // vm.$nextTick(() => {
    //   for (let i = 0; i < instances.length; i++) {
    //     const div = document.getElementById(ids[i]);
    //     if (div) div.appendChild(instances[i].$el);
    //   }
    // });
    // data-data削除
    return content
      .replace(/<img src=\'[^\']+\'/g, function (match) { // 画像パス変換
        return match.replace("src='", "src='/img/content/")
      })
  }
  // public static parseMathjax(vm: any, content: string): any {
  //   if (!content || content == "") return ""
  //   const result = content.match(/\$(.+)\$/);
  //   if (result == null || result.length == 0) return content
  //   const propsData: any = {};
  //   propsData["formula"] = result[0];
  //   console.log(vm.classes)
  //   const instance = BasicUtil.getComponent(vm.classes, "VueMathjax", propsData)
  //   if (!instance) return content
  //   if (instance) {
  //     instance.$mount();
  //   }
  //   const uuid = "i" + uuidv4()
  //   content = content.replace(/\$(.+)\$/g, '<span id="' + uuid + '"></span>');
  //   vm.$nextTick(() => {
  //     const div = document.getElementById(uuid);
  //     if (div && instance) div.appendChild(instance.$el);
  //   });
  //   // data-data削除
  //   return content
  // }


  public static onlyNumber(val: string): string {
    if (val.length == 0 || val == "") return "";
    val = val.replace(/,/g, '');
    val = val.replace(/０/g, '0');
    val = val.replace(/１/g, '1');
    val = val.replace(/２/g, '2');
    val = val.replace(/３/g, '3');
    val = val.replace(/４/g, '4');
    val = val.replace(/５/g, '5');
    val = val.replace(/６/g, '6');
    val = val.replace(/７/g, '7');
    val = val.replace(/８/g, '8');
    val = val.replace(/９/g, '9');
    if (/[^\-\.0-9]+/.test(val)) return "";
    return Number(val).toLocaleString()
  }

  public static justifyText(text: string) {
    if (text.indexOf('<span>') !== -1) {
      return text
    }
    const letters: string[] = []
    let isB: boolean = false
    text.split('').forEach((t: string) => {
      if (t == ")") isB = false
      if (isB) {
        letters.push("<span><b>" + t + "</b></span>")
      } else {
        letters.push("<span>" + t + "</span>")
      }
      if (t == "(") isB = true
    })
    return letters.join("")
  }

  public static arrayShuffle(array: any) {
    for (var i = (array.length - 1); 0 < i; i--) {

      var r = Math.floor(Math.random() * (i + 1));

      var tmp = array[i];
      array[i] = array[r];
      array[r] = tmp;
    }
    return array;
  }

  public static getQa3() {
    return {q: "351ページの決算整理後残高試算表の売上の金額４ケタ（カンマ入力不要）を半角で入力してください", a: "5000"};
  }



  public static getQa2(booktype: number) {
    if (booktype == 1) {
      return {q: "319ページの貸借対照表の受取手形の金額４ケタ（カンマ入力不要）を半角で入力してください", a: "1000"};
    } else {
      return {q: "233ページの損益計算書の当期製品製造原価の金額４ケタ（カンマ入力不要）を半角で入力してください", a: "1400"};
    }
    return {q: "", a: "123456789"};
  }

  public static setGradePass(shikenId: number): void {
    Cookies.set('bokiwebapp-' + String(shikenId), passObj[String(shikenId)], { expires: 365 });
  }

  public static isAuth(shikenId: number): boolean {
    const cookie = Cookies.get('bokiwebapp-' + String(shikenId))
    return cookie !== undefined && cookie == passObj[String(shikenId)]
  }

}